import { Search, X } from "lucide-react";
import Reveal from "@/components/Reveal";

export default function SearchBar({ query, onChange }) {
  return (
    <Reveal className="mx-auto max-w-xl px-5 md:px-10">
      <div className="relative">
        <Search className="pointer-events-none absolute left-6 top-1/2 h-5 w-5 -translate-y-1/2 text-gold" />
        <input
          value={query}
          onChange={(e) => onChange(e.target.value)}
          placeholder="Suche: Jhumka, Phulkari, Kundan, Dupatta…"
          className="w-full rounded-full border border-gold/30 bg-wine2/60 py-4 pl-14 pr-14 text-sm text-cream placeholder:text-cream/40 outline-none transition-colors duration-300 focus:border-gold"
          data-testid="search-input"
        />
        {query && (
          <button
            onClick={() => onChange("")}
            className="absolute right-5 top-1/2 -translate-y-1/2 text-cream/50 transition-colors duration-300 hover:text-gold"
            data-testid="search-clear"
            aria-label="Suche löschen"
          >
            <X className="h-5 w-5" />
          </button>
        )}
      </div>
    </Reveal>
  );
}

